import React from 'react';
import * as PropTypes from 'prop-types';
import {
  Image,
  Navbar as BootstrapNav,
  Nav,
  Tooltip,
  OverlayTrigger,
} from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faClipboard,
  faFolder,
  faQuestionCircle,
  faSignOut,
} from '@whitebox-learning/fontawesome-pro-light-svg-icons';
import * as pages from '../../constants/pages';
import { getRoutePath } from '../../config/routes';
import logo from '../../img/logo_72.png';

import './Navbar.sass';
import LevelProgressBar from '../Game/LevelProgressBar';

const Navbar = ({
  page,
  appName,
  gotoPage,
  openHelp,
  openFileManager,
  logout,
  gameMode,
  game,
  showGameProgress,
  showGameIntro,
}) => (
  <BootstrapNav bg="light" className="align-items-stretch" role="navigation" aria-label="Main navigation">
    <Nav id="app-name-nav">
      <BootstrapNav.Brand className="d-flex align-items-center">
        <Image src={process.env.PUBLIC_URL + '/img/wbl_logo_box.png'} alt="WhiteBox Learning" className="me-1" />
        <NavLink
          to={getRoutePath(pages.PAGE_HOME)}
          className="nav-link app-name ps-0 pe-3"
        >
          {appName}
        </NavLink>
      </BootstrapNav.Brand>
    </Nav>

    {gameMode ? (
      <Nav className="me-auto">
        <LevelProgressBar
          game={game}
          firstRun={false}
          toggleGameModal={showGameProgress}
          showInfo={showGameIntro}
        />
      </Nav>
    ) : (
      <div className="me-auto" />
    )}

    <Nav
      id="main-nav"
      className="me-auto align-items-center"
    >
      <NavLink
        to={getRoutePath(pages.PAGE_RESEARCH)}
        className="nav-link nav-research"
      >
        Research
      </NavLink>
      <NavLink
        to={getRoutePath(pages.PAGE_ENGINEERING)}
        className="nav-link nav-engineering"
      >
        Engineering
      </NavLink>
      <NavLink
        to={getRoutePath(pages.PAGE_SIMULATION)}
        className="nav-link nav-simulation"
      >
        Competition
      </NavLink>
      <NavLink
        to={getRoutePath(pages.PAGE_OUTPUTS)}
        className="nav-link nav-outputs"
      >
        Outputs
      </NavLink>
      <NavLink
        to={getRoutePath(pages.PAGE_BUILD)}
        className="nav-link nav-build"
      >
        Build
      </NavLink>
    </Nav>

    <Nav
      className="file-menu border-start ms-2 ps-2 align-items-center"
      onSelect={(key) => {
        switch (key) {
          case 'file':
            openFileManager();
            break;
          case 'help':
            openHelp();
            break;
          default:
            break;
        }
      }}
    >
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id="tooltip-fm">File Manager</Tooltip>}
      >
        <Nav.Link eventKey="file" id="nav-file">
          <FontAwesomeIcon icon={faFolder} size="lg" />
        </Nav.Link>
      </OverlayTrigger>
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id="tooltip-tuts">Tutorials</Tooltip>}
      >
        <Nav.Link eventKey="help" id="nav-tutorials">
          <FontAwesomeIcon icon={faQuestionCircle} size="lg" />
        </Nav.Link>
      </OverlayTrigger>
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id="tooltip-journal">Journal</Tooltip>}
      >
        <NavLink
          to={getRoutePath(pages.PAGE_JOURNAL)}
          className="nav-link"
          id="nav-journal"
        >
          <FontAwesomeIcon icon={faClipboard} size="lg" />
        </NavLink>
      </OverlayTrigger>
    </Nav>

    <Nav
      className="logout align-items-center border-start ms-2 ps-2 pe-2"
      onSelect={logout}
    >
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id="tooltip-signout">Sign Out</Tooltip>}
      >
        <Nav.Link eventKey="logout" id="nav-logout">
          <FontAwesomeIcon icon={faSignOut} size="lg" />
        </Nav.Link>
      </OverlayTrigger>
    </Nav>
  </BootstrapNav>
);
Navbar.propTypes = {
  gotoPage: PropTypes.func,
  openHelp: PropTypes.func,
  openFileManager: PropTypes.func,
  logout: PropTypes.func,
};

export default Navbar;
